<ng-container [ngSwitch]="pageLoadingState$ | async">
  <ng-container *ngSwitchCase="LoadingState.Pending">
    <div fxLayout style="margin-bottom: 24px; align-items: center; justify-content: center">
      <mat-spinner fxLayout fxLayoutAlign="center" [diameter]="30"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Success">
    <ng-template [ngTemplateOutlet]="allSet"></ng-template>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Error">
    <ng-template [ngTemplateOutlet]="error"></ng-template>
  </ng-container>
</ng-container>

<ng-template #allSet>
  <div
    class="text-left"
    fxLayout="column"
    fxLayoutAlign="start center"
    fxLayoutGap="32px"
    *ngIf="perms$.permissions | async as perms">
    <section fxFlexFill>
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M73.3327 36.9337V40.0004C73.3286 47.1884 71.001 54.1826 66.6971 59.9398C62.3932 65.6969 56.3436 69.9086 49.4505 71.9467C42.5575 73.9848 35.1902 73.74 28.4476 71.249C21.705 68.7579 15.9482 64.154 12.0359 58.1239C8.12357 52.0938 6.26532 44.9606 6.73827 37.7881C7.21122 30.6156 9.99004 23.7881 14.6603 18.3239C19.3305 12.8598 25.642 9.05164 32.6533 7.46752C39.6647 5.88339 47.0002 6.60815 53.566 9.5337"
          stroke="#47C693"
          stroke-width="6.15"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M73.3333 13.333L40 46.6997L30 36.6997"
          stroke="#47C693"
          stroke-width="6.15"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </section>

    <section fxLayout="column" fxLayoutGap="20px" fxFlexFill>
      <h2>You're all set!</h2>
      <span>You successfully connected your {{ platformString }} account to Hospitable.com, and also...</span>

      <ul class="list__results">
        <ng-container
          *ngIf="listingReviewsToBeCreatedLoadingStateCount$ | async as listingReviewsToBeCreatedLoadingStateCount">
          <li *ngIf="listingReviewsToBeCreatedLoadingStateCount[LoadingState.Success] > 0">
            <sbnb-icon icon="check-circle" class="icon__success"></sbnb-icon>
            Imported {{ listingReviewsToBeCreatedLoadingStateCount[LoadingState.Success] }}
            {{ 'properties' | pluralize: listingReviewsToBeCreatedLoadingStateCount[LoadingState.Success] }}
          </li>
          <li *ngIf="listingReviewsToBeCreatedLoadingStateCount[LoadingState.Error] > 0">
            <sbnb-icon icon="alert-circle" class="icon__error"></sbnb-icon>
            Failed to import {{ listingReviewsToBeCreatedLoadingStateCount[LoadingState.Error] }}
            {{ 'properties' | pluralize: listingReviewsToBeCreatedLoadingStateCount[LoadingState.Success] }}
          </li>
        </ng-container>

        <ng-container
          *ngIf="listingReviewsToBeMergedLoadingStateCount$ | async as listingReviewsToBeMergedLoadingStateCount">
          <li *ngIf="listingReviewsToBeMergedLoadingStateCount[LoadingState.Success] > 0">
            <sbnb-icon icon="check-circle" class="icon__success"></sbnb-icon>
            Added {{ listingReviewsToBeMergedLoadingStateCount[LoadingState.Success] }}
            {{ 'listings' | pluralize: listingReviewsToBeMergedLoadingStateCount[LoadingState.Success] }} to an existing
            property
          </li>

          <li *ngIf="listingReviewsToBeMergedLoadingStateCount[LoadingState.Error] > 0">
            <sbnb-icon icon="alert-circle" class="icon__error"></sbnb-icon>
            Failed to add {{ listingReviewsToBeMergedLoadingStateCount[LoadingState.Error] }}
            {{ 'listings' | pluralize: listingReviewsToBeMergedLoadingStateCount[LoadingState.Success] }} to an existing
            property
          </li>
        </ng-container>

        <ng-container
          *ngIf="listingReviewsToBeMutedLoadingStateCount$ | async as listingReviewsToBeMutedLoadingStateCount">
          <li *ngIf="listingReviewsToBeMutedLoadingStateCount[LoadingState.Success] > 0">
            <sbnb-icon icon="check-circle" class="icon__success"></sbnb-icon>
            Muted {{ listingReviewsToBeMutedLoadingStateCount[LoadingState.Success] }}
            {{ 'properties' | pluralize: listingReviewsToBeMutedLoadingStateCount[LoadingState.Success] }}
          </li>
          <li *ngIf="listingReviewsToBeMutedLoadingStateCount[LoadingState.Error] > 0">
            <sbnb-icon icon="alert-circle" class="icon__error"></sbnb-icon>
            Failed to mute {{ listingReviewsToBeMutedLoadingStateCount[LoadingState.Error] }}
            {{ 'properties' | pluralize: listingReviewsToBeMutedLoadingStateCount[LoadingState.Success] }}
          </li>
        </ng-container>

        <ng-container
          *ngIf="listingReviewsToBeUnMutedLoadingStateCount$ | async as listingReviewsToBeUnMutedLoadingStateCount">
          <li *ngIf="listingReviewsToBeUnMutedLoadingStateCount[LoadingState.Success] > 0">
            <sbnb-icon icon="check-circle" class="icon__success"></sbnb-icon>
            Unmuted {{ listingReviewsToBeUnMutedLoadingStateCount[LoadingState.Success] }}
            {{ 'properties' | pluralize: listingReviewsToBeUnMutedLoadingStateCount[LoadingState.Success] }}
          </li>
          <li *ngIf="listingReviewsToBeUnMutedLoadingStateCount[LoadingState.Error] > 0">
            <sbnb-icon icon="alert-circle" class="icon__error"></sbnb-icon>
            Failed to unmute {{ listingReviewsToBeUnMutedLoadingStateCount[LoadingState.Error] }}
            {{ 'properties' | pluralize: listingReviewsToBeUnMutedLoadingStateCount[LoadingState.Success] }}
          </li>
        </ng-container>
      </ul>
    </section>

    <section fxLayout="column" fxLayoutGap="20px" fxFlexFill>
      <span>What's next?</span>
      <ng-template [ngTemplateOutlet]="whatsNext"></ng-template>
    </section>
  </div>
</ng-template>

<ng-template #whatsNext>
  <section *ngIf="perms$.permissions | async as perms" fxLayout="column" fxLayoutGap="16px" fxFlexFill>
    <sbnb-completion-box
      *ngIf="perms.is_team_owner"
      heading="Visit the onboarding checklist"
      description="Get onboard with the essentials of {{ 'CORE.PRODUCT_NAME' | transloco }}"
      buttonLabel="Get started"
      [routerLink]="['/onboarding']"
      [highlight]="true"></sbnb-completion-box>

    <sbnb-completion-box
      heading="Connect another account"
      description="You can connect as many Airbnb, Vrbo and Booking.com accounts as you wish."
      buttonLabel="Connect another"
      [routerLink]="['/accounts']"></sbnb-completion-box>
  </section>

  <section style="width: 100%">
    <button
      mat-flat-button
      [ngClass.lt-md]="{ fw: true }"
      [routerLink]="['/properties/segments/4fb4073a-3ed3-42ec-8b7d-56f3fbdb13ec']">
      Thanks, I'm finished for now
    </button>
  </section>
</ng-template>

<ng-template #error>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <div>
      <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M75.7819 30.169V79.0313H14.6938V30.1487"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
          fill="#D0CDD4" />
      </svg>
    </div>
    <h2>Oops, an error has occurred</h2>

    <ng-template [ngTemplateOutlet]="whatsNext"></ng-template>
  </div>
</ng-template>
